// ============================================
// PIN Session Manager
// Quản lý session mã PIN bằng module-level variable (RAM only).
// - PIN chỉ tồn tại trong memory, mất khi refresh/close tab.
// - Tự hết hạn sau SESSION_DURATION_MS không có tương tác (API call).
// - Mỗi API call thành công sẽ gia hạn thêm SESSION_DURATION_MS.
// ============================================

/** Thời gian sống của PIN session (2 phút) */
const SESSION_DURATION_MS = 2 * 60 * 1000;

// Module-level state — chỉ mất khi refresh hoặc close tab
let _managerPin: string | null = null;
let _expiresAt = 0;

// Danh sách callback để thông báo khi session thay đổi
type SessionChangeListener = () => void;
const _listeners: Set<SessionChangeListener> = new Set();

/** Thông báo tất cả listener khi session thay đổi */
const _notifyListeners = () => {
  _listeners.forEach((listener) => listener());
};

export const pinSession = {
  /** Bắt đầu session mới với PIN đã verify */
  start(pin: string) {
    _managerPin = pin;
    _expiresAt = Date.now() + SESSION_DURATION_MS;
  },

  /** Lấy PIN nếu session còn hạn, ngược lại trả null và clear */
  getPin(): string | null {
    if (_managerPin && Date.now() < _expiresAt) {
      return _managerPin;
    }
    // Session hết hạn → tự dọn
    if (_managerPin) {
      this.clear();
    }
    return null;
  },

  /** Gia hạn thêm 2 phút — gọi sau mỗi API call thành công */
  renew() {
    if (_managerPin && Date.now() < _expiresAt) {
      _expiresAt = Date.now() + SESSION_DURATION_MS;
    }
  },

  /** Xóa session và thông báo listeners (hiện lại PIN dialog) */
  clear() {
    _managerPin = null;
    _expiresAt = 0;
    _notifyListeners();
  },

  /** Kiểm tra session còn valid không */
  isValid(): boolean {
    return !!_managerPin && Date.now() < _expiresAt;
  },

  /** Đăng ký listener khi session thay đổi (dùng trong React component) */
  subscribe(listener: SessionChangeListener): () => void {
    _listeners.add(listener);
    return () => {
      _listeners.delete(listener);
    };
  },
};
